import React, { useState } from "react";
import styles from "./NewQuestionBoxStyles.module.css";
import DropdownComponent from "../Dropdown/Dropdown";
import Answers from "../ansAccDoctype/Answers";
import { useLocation, useNavigate } from "react-router-dom";
import { markUnmarkFavourite } from "../../API/api";
import { bindActionCreators } from "redux";
import { Actions } from "../../Action";
import { useDispatch, useSelector } from "react-redux";
import moment from "moment";
import {convertEpochToTimestamp} from '../../utils';
import { Home_PAGE_URL } from "../../Router/routerUrl";
import AttachmentBox from "../AttachmentBox/AttachmentBox";
const NewQuestionBox = ({ data }) => {
  // console.log("data",data)
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const favouriteState = useSelector((state) => state.favouriteQuestions);
  const [isFavourite, setIsFavourite] = useState(data.favourite);
  const modalName = useSelector((state) => state.domain.modalName);
  const {recommendData, preservePreviousRecommendData, getkeyTagPayload, markedFavData, advanceFilterModalToggle} = bindActionCreators(Actions, dispatch)
  if(data.docType === undefined){
    data.question = data.text;
    if(data.questionText !== undefined){
      data.question = data.questionText;
    }
    data.answers = data.answersList;
  }
  const currentRoute = useLocation();
  const onClickFavourite = () =>{
    let filteredData = [];
    let id = data.origQuestionUuid !== undefined?data.origQuestionUuid:data.questionUuid;
    if(currentRoute.pathname.includes('/favourite')){
      filteredData = favouriteState.data.filter((data2) => {
        if (data.questionUuid === data2.questionUuid) {
          data2.favourite = false;
        }
        return data2;
      });
    }
    markUnmarkFavourite(id).then(res=>{
      if (res===undefined) return;
      setIsFavourite(!isFavourite);
      if(currentRoute.pathname.includes('/favourite')){
        markedFavData(filteredData);
      }
    }).catch(err=>{
      console.log(err);
    })
  }

  const generatingRelatedQ = (data) =>{
    if(data.text === undefined){
      data.text = data.questionText;
    }
    if(!data.reusableThreadQA){
      let payload ={
        data:{
          id:data.questionUuid,
        text:data.text
        }
      }
      preservePreviousRecommendData([])
      recommendData(payload);
      navigate(`${Home_PAGE_URL}recommend`);
    }else if(data.reusableThreadQA){
      if(data.status === 'accepted'){
        let payload ={
          data:{
            id:data.questionUuid,
          text:data.text
          }
        }
        preservePreviousRecommendData([])
        recommendData(payload);
        navigate(`${Home_PAGE_URL}recommend`);
      }
    }

  }
  const momentit = (stime) => {
    if (Number(Date.now()) - Number(stime) < 259200000) {
      return moment(new Date(Number(stime))).fromNow();
    } else {
      return moment(convertEpochToTimestamp(stime)).format("ll");
    }
  };
  
  const selectTag = (tag) => {
    advanceFilterModalToggle({ bool: false, value: "" })
    getkeyTagPayload(null);
    getkeyTagPayload(tag);
    if(!currentRoute.pathname.includes(`${Home_PAGE_URL}tagdata`)){
      navigate(`${Home_PAGE_URL}tagdata`);
    }
  }
  return (
    <>
        <div className={styles.container}>
          <div className={styles.leftContainer} style={{backgroundColor:`${
            currentRoute.pathname.includes("/search") ?data.confidence ? 'green' : 'orange':'var(--light_color_shade)'
          }`}}>
            <div style={{paddingTop:'.5rem',textAlign:'center', fontWeight:'bold', color:'#fff'}}>
              {(data.docType === "expertqa" || data.docType === undefined ) && 'Q&A'}
              {(data.docType === "Email") && <i style={{fontSize:'21px',borderColor:'#fff', fontWeight:'bold', color:'#fff', paddingTop:'0px'}} className="fa fa-envelope documentIcon"></i>}
              {(data.docType === "urlcrawl") && <i style={{fontSize:'21px',borderColor:'#fff', fontWeight:'bold', color:'#fff'}} className="fa fa-link documentIcon"></i>}
              {(data.docType === "Video") && <i style={{fontSize:'21px',borderColor:'#fff', fontWeight:'bold', color:'#fff'}} className="fa fa-file-video-o documentIcon"></i>}
              {(data.docType === "Pdf" || data.docType==="Image") && <i style={{fontSize:'21px',borderColor:'#fff', fontWeight:'bold', color:'#fff'}} className="fa fa-file documentIcon"></i>}
              {(data.docType === "Thread") && <i style={{fontSize:'21px',borderColor:'#fff', fontWeight:'bold', color:'#fff'}} className="fa fa-comments documentIcon"></i>}
              </div>
          </div>
        <div className={`${styles.rightContainer} `}>
        {(data.docType === "expertqa" || data.docType === undefined || data.docType === 'Email' ) && data.question !== undefined && <div className={styles.heading}>
            {(currentRoute.pathname.includes("/search") || currentRoute.pathname.includes("/editor")) && <div>
              <h2 className={styles.question}>{data.question}</h2>
              {data.seekerAttachments && data.seekerAttachments.length > 0 &&
                <div>{data.seekerAttachments.map((obj, ind) => {
                  return <AttachmentBox attachment={obj} key={ind} />
                })}</div>}
            </div>}
        {!data.reusableThreadQA && !currentRoute.pathname.includes("/editor")&& !currentRoute.pathname.includes("/search") && <div className={styles.underlineQuestion}>
        <h2 className={styles.question} onClick={()=>generatingRelatedQ(data)}>{data.question}</h2>
        </div>}
        {data.reusableThreadQA  && (currentRoute.pathname.includes("/trending") || currentRoute.pathname.includes("/answered") || currentRoute.pathname.includes("/favourite")) && <div className={`${data.status==='accepted'&&styles.underlineQuestion}`}>
        <h2 onClick={()=>generatingRelatedQ(data)} className={styles.question}>{data.question}</h2>
        </div>}
        {!currentRoute.pathname.includes("/editor") && !currentRoute.pathname.includes("/favourite") && modalName !== "generativeREsponse" && <div style={{marginLeft:'.2rem'}}>
        {data.docType !=='Email' && data.status !== "accepted"?!data.reusableThreadQA && <DropdownComponent question={data} />:!data.reusableThreadQA && data.docType !=='Email' && <i className='fa fa-heart' style={{cursor:'pointer',color:isFavourite?'#FF6A00':'lightgray'}} onClick={()=>{onClickFavourite()}}></i>}
        </div>}
        {!currentRoute.pathname.includes("/editor") && data.docType !=='Email' && !currentRoute.pathname.includes("/favourite") && modalName !== "generativeREsponse" && data.status === "accepted" && data.reusableThreadQA && <div style={{marginLeft:'.2rem'}}>
        <i className='fa fa-heart' style={{cursor:'pointer',color:isFavourite?'#FF6A00':'lightgray'}} onClick={()=>{onClickFavourite()}}></i>
        </div>}
        {currentRoute.pathname.includes("/favourite") && <div style={{marginLeft:'.2rem'}}>
        {data.docType !=='Email' && data.status !== "accepted"? data.answers.length !== 0 ?<DropdownComponent question={data} /> : <i className='fa fa-heart' style={{cursor:'pointer',color:'#FF6A00'}} onClick={()=>{onClickFavourite()}}></i>:<i className='fa fa-heart' style={{cursor:'pointer',color:'#FF6A00'}} onClick={()=>{onClickFavourite()}}></i>}
        </div>}
        </div>}
        {data.additionalContext && data.question !== undefined && (
                <div className={styles.additionalCont}>
                  <span>{data.additionalContext}</span>
                </div>
              )}
        {(data.docType === "expertqa" || data.docType === undefined )&& data.question !== undefined && data.domain && <div className={styles.domainAndTagsContainer}>
        {data.domain && <div className={styles.domainContainer} >Domain:                      
          <span className={styles.domainLabel}>{data.domain}</span>
        </div>}
        {data.tags && data.tags.length > 0&& data.question !== undefined && <div className={styles.domainContainer}>Tags:{" "}{data.tags &&
                          data.tags.map((tag, index) => (
                            <span className={tag.clickable?styles.tagLabelClickable2:styles.tagLabel} onClick={()=>selectTag(tag)}>{tag.term}</span>
                          ))}
          </div> }
        </div>}
        {(data.docType === 'expertqa' || data.docType === undefined)&& data.question !== undefined && data.isShowUpdateRequestWarning && <span className="requestUpdateNeeded">Recommended request for update; this answer may not be up-to-date.</span>}
        {data.answers &&
            data.answers.map((answer, index) => {
              return (
                <div key={index}>
                  <Answers question={data} answer={answer} />
                  {data.answers.length - 1 !== index && <p style={{margin:'0px', marginTop:'5px'}}><hr style={{marginInline:'1.5rem'}}/></p>}
                </div>
              );
            })}
          {data.answers && data.answers.length === 0 && <p className={styles.unanswered_q}>No Answer Yet!</p>}
        </div>
        </div>     
    </>
  );
};

export default NewQuestionBox;
